import { render, staticRenderFns } from "./personageIndex.vue?vue&type=template&id=7d9b3926&"
import script from "./personageIndex.vue?vue&type=script&lang=js&"
export * from "./personageIndex.vue?vue&type=script&lang=js&"
import style0 from "./personageIndex.vue?vue&type=style&index=0&id=7d9b3926&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports